import { deleteCommitFile } from "../stepTrees";
import { loadCommitFileRow, loadCommitFileRows } from "../commitFileRows";
import type { writeCommitFile } from "../commitFiles";
import {
  STEP_TEST_CASES_DIR,
  STEP_TEST_CLOCK_SUFFIX,
} from "../stepTests/constants";
import { STEP_TEST_REQUESTS_SUFFIX } from "../stepTests/requests";
import { volumeFixtureBaseRelPath } from "../stepTests/volumes";

type StepTestFileTx = Parameters<typeof writeCommitFile>[0]["tx"];

export async function deleteStepTestVolumeFixtureFiles({
  tx,
  commitId,
  stepDir,
  name,
}: {
  tx: StepTestFileTx;
  commitId: string;
  stepDir: string;
  name: string;
}) {
  const prefix = `${stepDir}/${volumeFixtureBaseRelPath(name)}/`;
  const files = (await loadCommitFileRows(tx, commitId)).filter((file) =>
    file.path.startsWith(prefix)
  );
  for (const file of files) {
    await deleteCommitFile(tx, commitId, file.path);
  }
}

export async function deleteStepTestClockFile({
  tx,
  commitId,
  stepDir,
  name,
}: {
  tx: StepTestFileTx;
  commitId: string;
  stepDir: string;
  name: string;
}) {
  const clockPath = `${stepDir}/${STEP_TEST_CASES_DIR}/${name}${STEP_TEST_CLOCK_SUFFIX}`;
  const clockFile = await loadCommitFileRow(tx, commitId, clockPath);
  if (clockFile) {
    await deleteCommitFile(tx, commitId, clockPath);
  }
}

export async function deleteStepTestRequestsFile({
  tx,
  commitId,
  stepDir,
  name,
}: {
  tx: StepTestFileTx;
  commitId: string;
  stepDir: string;
  name: string;
}) {
  const requestsPath = `${stepDir}/${STEP_TEST_CASES_DIR}/${name}${STEP_TEST_REQUESTS_SUFFIX}`;
  const requestsFile = await loadCommitFileRow(tx, commitId, requestsPath);
  if (requestsFile) {
    await deleteCommitFile(tx, commitId, requestsPath);
  }
}
